export default "__VITE_ASSET__Bk8fxNMa__"